import { getExtSensorsStatus } from 'src/helpers/ext_sensor_helpers';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

export const refactorString = (string, device) => {
	const _format = get(format);

	let notExtSensorNumber = '';
	// check if actionString contains a number (notExtSensorNumber)
	if (/\d/.test(string)) {
		let notExtSensorNumberIndex = string.search(/\d/);
		notExtSensorNumber = string[notExtSensorNumberIndex];

		// check if index is not at the beggining of the string
		if (notExtSensorNumberIndex !== 3) {
			const allSensors = getExtSensorsStatus(device);

			// remove the number from the string to get the translation key
			const translationKey = string.slice(0, string.length - 2);

			const sensorIndex = string.slice(string.length - 1, string.length);

			if (device.category === 'emeter') {
				return 'Channel' + ' ' + sensorIndex + ' ' + _format(translationKey);
			}

			return allSensors[sensorIndex]?.sensor?.name
				? allSensors[sensorIndex]?.sensor?.name + ' ' + _format(translationKey)
				: _format(translationKey);
		}
		string = string.slice(0, notExtSensorNumberIndex) + string.slice(notExtSensorNumberIndex + 1); // removes the notExtSensorNumber
	}
	// check if you have notExtSensorNumber & 'url', add them if you don't
	return (
		(notExtSensorNumber ? notExtSensorNumber + ' ' : '') +
		_format(string?.indexOf('_url') > -1 ? string : string + '_url')
	);
};
